fx.ns("shared.stage.components", class Background extends shared.stage.base.MediaComponent{
    
	constructor(component, model, parent, manual, commands)
	{
		super(component, model, parent, commands, model.backgrounds, manual);

		this.showActions = false;
		this.selectable = false;
	}

	get extraWidth()
	{
		return this.parent.extraWidth || 0;
	}

    get isSlice()
    {
        return this.component.creation == "slice"
    }

	create()
    {
		super.create();

		this.image = new fx.components.Image();
		this.image.attr("draggable", false)
				  .attr("data-id", this.data.id)
				  .attr("data-drop-allowed", true);

		
		this.addChild(this.image, {height :"100%", width : "100%"});

		//if (!this.single)
		//{

        if (fx.get("app") != "calendar")
        {
			this.gradientBackground = new fx.components.Box();
			this.gradientBackground.visibleAtStart = !this.single;
			this.addChild(this.gradientBackground, {height :"100%", width : "100%"});
        }
		//}
	}

	onReady()
	{
		this.addClass("fixed");
	}

	/**
	 * If no content , hide image
	 */
	updateMedia(content) 
    {
		/*if (!content)
		{
			this.image.data = "";

			if (this._media)
			{
				this._listenMedia(false);
				this._media.using(false);
				this._media = null;
			}
		}
		else
		{
			super.updateMedia(content);
		}*/
		
        super.updateMedia(content);
        
		if (content && !this._media) // so background was deleted
		{
			this.data.content = "";
		}
	}
	
	/**
	 * Background has always the same size as stage 
	 */
	onDisplayUpdated()
	{
		if (!this.image || !this.component || this.parent.realWidth == 0)
			return;

		if (!this.visible)
		{
            this.show();
			return;
		}


        if (this.model.creation instanceof models.ProductPrint)
        //if (fx.get("app") =="print")
        {
                let pageWidth = this.parent.width();
                let pageHeight = this.parent.height();

                let photoComponent = this.parent.data ? this.parent.data.photosComponents.getItemAt(0) : null;

                if (photoComponent && (photoComponent.width < photoComponent.height) != (pageWidth < pageHeight))
                {
                    pageWidth = this.parent.height();
                    pageHeight = this.parent.width();
                }

               this.css({	width :  pageWidth,
                            height : pageHeight,
                            transform: "translate(0px,0px)"
                        });

                this.image.css({	width : pageWidth,
                                    height : pageHeight,
                                    transform:  "translate(0,0) rotate(0)"
                                });
        }
        else
        if (this.model.creation instanceof models.ProductCalendar)
        //if (fx.get("app") =="calendar")
        {
            if (this.component.creation == "top")
            {
                this.css({	width :  this.model.creation.pageWidth, 
                            height : this.model.creation.pageHeight,
                            transform: "translate(0px,0px)"
                        });

                this.image.css({	width : this.model.creation.pageWidth, 
                                    height : this.model.creation.pageHeight,
                                    transform:  "translate(0,0) rotate(0)"
                                });
            }
            else
            if (this.component.creation == "bottom" || (this.component.creation == "" && fx.get("app") =="calendar" && this.model.creation.cover_option == "wall-double"))
            {
                    this.css({	width : this.model.creation.pageWidth, 
                                height : this.model.creation.pageHeight,
                                transform : "translate(0px," + this.model.creation.pageHeight + "px)"
                            });

                    this.image.css({	width : this.model.creation.pageWidth, 
                                        height : this.model.creation.pageHeight,
                                        transform : "translate(0px," + this.model.creation.pageHeight + "px) rotate(0) scale(1,-1)"
                                    });
            }
            else
            {
                 this.css({	width :  this.model.creation.pageWidth, 
                            height : this.model.creation.pageHeight,
                            transform: "translate(0px,0px)"
                        });

                this.image.css({	width : this.model.creation.pageWidth, 
                                    height : this.model.creation.pageHeight,
                                    transform:  "translate(0,0) rotate(0)"
                                });
            }

        }
        else
        {
		
            // SLICE CONTENT IS DISPLAYED
            if (this.component.align == "split")
            {
                if (this.component.creation == "slice")
                {
                    this.css({width : (this.parent.data.isCover ? this.model.creation.sliceWidth : 0), height : this.model.creation.pageHeight});
                    this.css("transform", "translate(" + this.model.creation.pageWidth + "px," + 0 + "px)");
                    this.css("opacity", 1);
                }
                else
                if (this.component.creation == "left")
                {
                    this.css({	width :  this.model.creation.pageWidth, 
                                height : this.model.creation.pageHeight,
                                transform: "translate(0px,0px)"
                            });

                    this.image.css({	width : this.model.creation.pageWidth, 
                                        height : this.model.creation.pageHeight,
                                        transform:  "translate(0,0) rotate(0)"
                                    });

                    if (this.gradientBackground)
                        this.gradientBackground.css({
                                                        width : this.model.creation.pageWidth, 
                                                        height : this.model.creation.pageHeight,
                                                        "transform" : "translate(0,0)"
                                                    });
                }
                else
                if (this.component.creation == "right")
                {
                    this.css({	width : this.model.creation.pageWidth, 
                                height : this.model.creation.pageHeight,
                                transform : "translate(" + (this.model.creation.pageWidth + (this.parent.data.isCover ? this.model.creation.sliceWidth : 0) ) + "px,0px)"
                            });

                    this.image.css({	width : this.model.creation.pageWidth, 
                                        height : this.model.creation.pageHeight,
                                        transform : "translate(" + this.model.creation.pageWidth + "px,0) rotate(0) scale(-1,1)"
                                    });
                    
                    if (this.gradientBackground)
                        this.gradientBackground.css({
                                                        width : this.model.creation.pageWidth, 
                                                        height : this.model.creation.pageHeight,
                                                        "transform" : "translate(0,0)"
                                                    });
                }
            }
            else // SLICE CONTENT IS HiDDEN, SO WE STRETCH LEFT AND RIGHT SIDE
            {
                if (this.component.creation == "slice")
                {
                    this.css("opacity", 0);
                }
                else
                if (this.component.creation == "left")
                {
                    this.css({	width : this.model.creation.pageWidth, 
                                height : this.model.creation.pageHeight,
                                transform : "translate(0px,0px)"
                            });

                    this.image.css({	width : this.model.creation.pageWidth, 
                                        height : this.model.creation.pageHeight,
                                        transform : "translate(0,0) rotate(0)"
                                    });
                    
                    if (this.gradientBackground)
                        this.gradientBackground.css({
                                                    width : this.model.creation.pageWidth, 
                                                    height : this.model.creation.pageHeight,
                                                    transform : "translate(0px,0px)"
                                                });
                    
                }
                else
                if (this.component.creation == "right")
                {
                    
                    this.css({	width : this.model.creation.pageWidth + (this.parent.data.isCover ? this.model.creation.sliceWidth : 0), 
                                height : this.model.creation.pageHeight,
                                transform : "translate(" + this.model.creation.pageWidth   + "px,0px)"
                            });
                    
                    this.image.css({	width : this.model.creation.pageWidth + (this.parent.data.isCover ? this.model.creation.sliceWidth : 0), 
                                        height : this.model.creation.pageHeight,
                                        transform: "translate(" + (this.model.creation.pageWidth + (this.parent.data.isCover ? this.model.creation.sliceWidth : 0)) + "px,0) rotate(0) scale(-1,1)"});
                        
                    if (this.gradientBackground)
                        this.gradientBackground.css({
                                                        width : this.model.creation.pageWidth + (this.parent.data.isCover ? this.model.creation.sliceWidth : 0),
                                                        height : this.model.creation.pageHeight,
                                                        transform : "translate(" + (this.parent.data.isCover ? this.model.creation.sliceWidth : 0) + "px,0px)"});
                    
                }
                else
                //if (this.component.creation == "")
                {
                    this.css({	width : this.model.creation.pageWidth, 
                                height : this.model.creation.pageHeight,
                                transform : "translate(0px,0px)"
                            });

                    this.image.css({	width : this.model.creation.pageWidth, 
                                        height : this.model.creation.pageHeight,
                                        transform : "translate(0,0) rotate(0)"
                                    });
                    
                    if (this.gradientBackground)
                        this.gradientBackground.css({
                                                    width : this.model.creation.pageWidth, 
                                                    height : this.model.creation.pageHeight,
                                                    transform : "translate(0px,0px)"
                                                });
                    
                }
            }
    }
			
	}



	
	onDataEvent(event)
    {
		super.onDataEvent(event);
		
        switch(event.type)
        {
            case "drag-over":
                this.updateMedia(event.detail.overcontent);
                event.stopPropagation();  
                break;

            case "drag-out":   
                this.updateMedia(this.component.content);
                event.stopPropagation(); 
                break;
        }
    }

	onDataUpdated(action)
    {
		super.onDataUpdated(action);

		if (action.type == "init")
		{
			this.image.attr("data-id", this.component.id)
				  	  .attr("data-side", this.component.creation);

			this.updateMedia(this.component.content);

			let hasMedia = !(this.media instanceof models.EmptyMedia) && this.component.content;
			this.css("background-color", hasMedia ?  "transparent" : this.backgroundColor );

			this._updateBackgroundGradient();
			this.onDisplayUpdated();

			if (!hasMedia)
				this.data.event("media-loaded", null, 500);
		}

		if (action.impacts("content"))
			this.updateMedia(this.component.content);
			
		if (action.impacts("bgcolor"))	
			this.css("background-color",  this.backgroundColor);
		
		if (action.impacts("align"))	
			this.onDisplayUpdated();

		if (action.impacts("id"))
			this.image.attr("data-id", this.component.id);
	}

	get backgroundColor()
	{
		let alpha = fx.graphics.getColorAlpha(this.component.bgcolor);

		if (alpha == 0) 
			return "rgba(255,255,255,1)";
		else
			return this.component.bgcolor;
	
	}


	_updateBackgroundGradient()
	{
		if (!this.gradientBackground)
			return;

    	let gradientcolor = "transparent";
		let oppositecolor = "rgba(8, 8, 8, 0.20)"

		let color = tinycolor(this.media ? this.media.bgcolor : this.component.bgcolor);
		if (color.isDark())
			oppositecolor = "rgba(180, 180, 180, 0.35)";
		
		if (this.component.creation == "left")
			this.gradientBackground.css("background", "linear-gradient(to right, " + gradientcolor + " 0%, " + gradientcolor + " 97%, " + oppositecolor + " 100%)");
		else
		if (this.component.creation == "right")
			this.gradientBackground.css("background", "linear-gradient(to left, " + gradientcolor + " 0%, " + gradientcolor + " 97%, " + oppositecolor + " 100%)");
		
		
	}
});